import TranslationKeys from "../../../../contexts/I18nContext/translationKeys";
import { Translate, TranslateHtml } from "../../../Translation/Translate";
import React from "react";
import { InvestmentProfileDto } from "../../../../data/dtos/investment-profile.dto";
import { VerificationStatuses } from "../../../../data/types/investors";
import { AccreditationAlert } from "./AccreditationAlert";
import { AccreditationButton } from "./AccreditationButton";
import { InfoCard } from "../../shared/InfoCard";

interface AccreditationCardProps {
  investmentProfileData?: InvestmentProfileDto;
  additionalAccreditation: boolean;
  currentPath: string;
}

export const AccreditationCard: React.FC<AccreditationCardProps> = ({
  additionalAccreditation,
  investmentProfileData,
  currentPath,
}) => {
  return (
    <InfoCard
      title={
        <Translate
          translationKey={
            TranslationKeys.PROFILE_INVESTMENT_PROFILE_ACCREDITATION_CARD_TITLE
          }
        />
      }
      subtitle={
        <TranslateHtml
          translationKey={
            TranslationKeys.PROFILE_INVESTMENT_PROFILE_ACCREDITATION_CARD_SUBTITLE
          }
        />
      }
      smallPadding
    >
      {investmentProfileData?.verificationStatus ===
        VerificationStatuses.NONE && (
        <AccreditationAlert currentPath={currentPath} />
      )}
      {investmentProfileData && (
        <AccreditationButton
          additionalAccreditation={additionalAccreditation}
          accreditationStatus={investmentProfileData.accreditationStatus}
          verificationStatus={investmentProfileData.verificationStatus}
          currentPath={currentPath}
        />
      )}
    </InfoCard>
  );
};
